/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradereportingV1CaisReportEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADEREPORTING_V1_CAIS_REPORT_EVENT_ENTITY_NAME = 'ixc.tradereporting.v1.CaisReportEvent';
export const ixcTradereportingV1CaisReportEventEntity = new schema.Entity<IxcTradereportingV1CaisReportEvent>(IXC_TRADEREPORTING_V1_CAIS_REPORT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcTradereportingV1CaisReportEvent) => `${entity.metadata?.eventId}` });

